module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10Fjjqh/images/cover.jpg?1708648506520",
      "alt": "This image is the cover for the book Your Blueprint for Life"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Your Blueprint for Life\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Your Blueprint for Life")])]), _c('b', [_vm._v(" gives the strategies readers need to align their passions, gifts, and calling.")])]), _c('p', [_vm._v("As CEO of the Blueprint for Life ministry, Michael Kendrick is devoted to helping others discover God’s purpose for their lives. "), _c('i', [_vm._v("Your Blueprint for Life ")]), _vm._v("guides readers toward a Christ-honoring life—one that brings joy spiritually, financially, relationally, physically, and professionally. With practical guidance for discovering passion, gifts, and callings, "), _c('i', [_vm._v("Your")]), _c('i', [_vm._v("Blueprint for Life")]), _vm._v(" gives readers concrete strategies for achieving the life they were created to lead, such as:")]), _vm._v("Intentionally carve out a specific time each day to hear from GodPrune your relational portfolioStep into your children’s worldRemember you are a steward of God’s resources, not an owner of your resources"), _c('p', [_vm._v("For anyone who has ever wondered why they were put on earth, "), _c('i', [_vm._v("Your")]), _c('i', [_vm._v("Blueprint for Life")]), _vm._v(" not only answers the question, but it also gives readers a solid guide to understanding and achieving God’s vision for their lives.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Kendrick\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0